import {ReactElement, useState} from 'react';
import {
  InputAdornment,
  TextField,
  IconButton,
  OutlinedTextFieldProps,
  Box
} from '@mui/material';
import theme from 'src/styles/theme';
import {TextLabelWrapperComponentDiv} from './TextInputStyle';

interface TextInputProps extends OutlinedTextFieldProps {
  field?: any;
  id?: any;
  label?: any;
  name: string;
  variant: any;
  placeholder?: string;
  value?: any;
  Icon?: any;
  adornmentPosition?: any;
  callback?: any;
  search?: any;
  onBlurCallback?: any;
  onFocusCallback?: any;
  onChangeCallback?: any;
  readOnly?: boolean;
  multiline?: true;
  minRows?: any;
  type?: string;
  minLength?: any;
  maxLength?: any;
  keyPressCallBack?: any;
  autoFocus?: boolean;
  disabled?: boolean;
  iconDisabled?: boolean;
  onClick?: any;
  size?: any;
  className?: any;
  OnMousePDownCallBack?: any;
  EndIcon?: any;
}

const TextInput = (props: TextInputProps): ReactElement => {
  // const {field, id, label,  = props;

  const {
    id,
    label,
    field,
    placeholder,
    variant,
    name,
    value,
    adornmentPosition,
    Icon,
    callback,
    search,
    onBlurCallback,
    onFocusCallback,
    onChangeCallback,
    readOnly,
    multiline,
    type,
    minRows,
    minLength,
    maxLength,
    keyPressCallBack,
    autoFocus,
    disabled,
    iconDisabled,
    onClick,
    size,
    className,
    OnMousePDownCallBack,
    EndIcon,
    ...rest
  } = props;

  const [currentValue, setCurrentValue] = useState<string>('');

  const handleCurrentValueChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCurrentValue(event.target.value);
    if (onChangeCallback) {
      onChangeCallback(event);
    }
  };

  return (
    <TextLabelWrapperComponentDiv disabled={disabled}>
      {/* <InputField {...field} {...rest} /> */}

      <TextField
        id={id || name}
        label={<Box px={1}>{label}</Box>}
        fullWidth
        className={className}
        placeholder={placeholder}
        variant={variant || 'outlined'}
        name={name}
        type={type}
        autoFocus={autoFocus}
        size={size || 'medium'}
        multiline={multiline}
        minRows={minRows}
        onChange={callback || handleCurrentValueChange}
        disabled={disabled}
        onKeyUp={search}
        onBlur={onBlurCallback}
        onFocus={onFocusCallback}
        onClick={onClick}
        value={(currentValue?.length ? currentValue : value) || ''}
        inputProps={{
          minLength: minLength ? String(minLength) : null,
          maxLength: maxLength ? String(maxLength) : null
        }}
        InputProps={{
          readOnly: readOnly || false,
          disabled: disabled || false,
          startAdornment: adornmentPosition === 'start' && (
            <InputAdornment position="start">
              <Icon />
            </InputAdornment>
          ),
          endAdornment: EndIcon && (
            <InputAdornment position="end">
              <IconButton
                disabled={iconDisabled}
                onClick={keyPressCallBack}
                onMouseDown={OnMousePDownCallBack}
                edge="end">
                <EndIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
        sx={{
          '& .MuiInputBase-input.Mui-disabled': {
            WebkitTextFillColor: theme.palette.common.black
          }
        }}
        {...field}
        {...rest}
      />
    </TextLabelWrapperComponentDiv>
  );
};
export default TextInput;
